import { WitboostTemplate } from '@agilelab/plugin-wb-builder-common';
import { WbNoData, WbTabsContent } from '@agilelab/plugin-wb-platform';
import pluralize from 'pluralize';
import { FC, useMemo } from 'react';
import {
  groupTemplateBySection,
  sortByTemplateClassType,
  templateTitles,
} from '../../template.utils';
import { TemplateList } from '../TemplateList';
import { useScaffolderPageContext } from './context/useScaffolderPageContext';
import { useWitboostCustomTemplates } from './utils';
import { Progress } from '@mainstage/core-components';

export const ScaffolderCards: FC = () => {
  const { entities, loading } = useScaffolderPageContext();
  const witboostCustomTemplates = useWitboostCustomTemplates(entities);
  const templatesByType = useMemo(() => {
    const unsortedTemplates = groupTemplateBySection(
      entities as WitboostTemplate[],
    );
    return Object.fromEntries(
      Object.entries(unsortedTemplates).sort(sortByTemplateClassType),
    );
  }, [entities]);

  if (loading) return <Progress />;

  if (!entities.length) return <WbNoData />;

  return (
    <WbTabsContent value="grid">
      {templatesByType &&
        Object.keys(templatesByType).map((templateType, index) => (
          <TemplateList
            key={index}
            group={{
              title: templateType,
              filter: (entity: WitboostTemplate) => {
                return entity.metadata.classDetails
                  ? entity.metadata.classDetails.pluralizedDisplayName ===
                      templateType ||
                      (entity.metadata.classDetails.displayName &&
                        pluralize(entity.metadata.classDetails.displayName) ===
                          templateType) ||
                      (templateType === 'Others' &&
                        !entity.metadata.classDetails.pluralizedDisplayName &&
                        !entity.metadata.classDetails.displayName)
                  : templateTitles(entity.spec.type) === templateType;
              },
            }}
            witboostCustomTemplates={witboostCustomTemplates}
          />
        ))}
    </WbTabsContent>
  );
};
